export * from './feld-gespeichert.interface';
